/* eslint-disable no-param-reassign */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import { course } from '@/api';
import {
  callNativeFunction,
  nativeFunction,
  getOs,
} from '@/utils/detectDevice';
import Path from './component/path';
import Dots from './component/dots';
import Background from './component/background';
import { getCoordinates } from './coordinates';
import DeviceContext from './component/device-context';
import './style.less';
import { DEVICE } from '../../constants';

const dotR = {
  [DEVICE.MOBILE]: 35,
  [DEVICE.PAD]: 53,
};

const pathWidth = {
  [DEVICE.MOBILE]: 4,
  [DEVICE.PAD]: 6,
  [DEVICE.PC]: 6,
};

const svgSetting = {
  [DEVICE.MOBILE]: { width: '100%', height: '100%', viewBox: '375 667' },
  [DEVICE.PAD]: { width: '100%', height: '100%', viewBox: '1024 768' },
  [DEVICE.PC]: { width: 1280, height: 800, viewBox: '1280 800' },
};

@withRouter
class Stage extends PureComponent {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
  };

  state = {
    coordinates: [],
    size: {},
    theme: get(this.props.match, 'params.theme', 's3').toLowerCase(),
    os: getOs(),
    stages: [],
    canChangeStage: false,
  };

  componentWillMount() {
    // console.log('componentWillMount');
    this.init();
  }

  componentWillReceiveProps(nextProps) {
    const { match: { params } } = this.props;
    const { match: { params: nextParams } } = nextProps;
    if (params !== nextParams) {
      this.setState({
        theme: nextParams.theme.toLowerCase(),
      }, () => {
        this.init();
      });
    }
  }

  init = async () => {
    // console.log('init-start');
    this.setState({ canChangeStage: false });
    const {
      state: { os },
      props: { match: { params: { id } } },
    } = this;
    const { code, data: stages, msg } = await course.list(id);
    const logTable = {};
    stages.forEach((item) => {
      logTable[item.fullname] = `https://library.riselinkedu.com/prestage/${id}/${item.scorm_id}`;
    });
    // console.log(theme);
    console.dir(logTable);
    callNativeFunction(nativeFunction.CHECK_LOCAL_DATA)();
    if (code === 200) {
      this.setState(({ coordinates }) => ({
        stages,
        size: {},
        coordinates: coordinates.length === 0
          ? getCoordinates(stages.length, os)
          : [],
      }), () => {
        this.state.coordinates.length === 0
          && this.setState({ coordinates: getCoordinates(stages.length, os) });
      });
    } else {
      console.log('error:', msg);
    }
    // console.log('init-end');
  }

  setSize = (coor) => {
    const { os } = this.state;
    // let size = {};
    // if (os === DEVICE.MOBILE) size = { height: coor.height };
    // if (os === DEVICE.PAD) size = { width: coor.width };

    const mobileSize = { height: coor.height };
    const otherSize = (os === DEVICE.PAD) ? { width: coor.width } : {};
    const size = (os === DEVICE.MOBILE)
      ? mobileSize
      : otherSize;
    // console.log('size', size);
    this.setState({ size }, () => this.setState({ canChangeStage: true }));
  }

  goCategories = () => {
    this.props.history.push('/categories');
  }

  changeStage = () => {
    const {
      state: { theme, canChangeStage },
      props: { match: { params: { id2, id } } },
    } = this;
    console.log(theme, id, id2, canChangeStage);
    canChangeStage && this.props.history.push(`/stage/${theme.toLowerCase() === 's2' ? 'S3' : 'S2'}/${id2}/${id}`);
  }

  render = () => {
    const {
      coordinates,
      size,
      os,
      theme,
      stages,
    } = this.state;
    const { match: { params: { id, id2 } } } = this.props;
    const hasBg = os === DEVICE.PC || (size.height || size.width);
    const stageId = id2 ? `${id}-${id2}` : id;
    return (
      <DeviceContext.Provider value={os}>
        <div className={`stage ${os} ${theme}`}>
          <div className="quit" onClick={this.goCategories} />
          {id2 && <div className={`change-stage ${theme.toLowerCase()}`} onClick={this.changeStage} />}
          <div className="stage-container" style={{ ...size }}>
            {hasBg && <Background size={size} os={os} theme={theme} />}
            <div className="path" style={{ ...size }}>
              {coordinates.length
                ? (
                  <Path
                    coordinates={coordinates}
                    r={dotR[os]}
                    width={pathWidth[os]}
                    svgSetting={svgSetting[os]}
                  />
                )
                : ''}
              {coordinates.length
                ? (
                  <Dots
                    coordinates={coordinates}
                    stages={stages}
                    setSize={this.setSize}
                    r={dotR[os]}
                    theme={this.props.match.params.theme}
                    stageId={stageId}
                    svgSetting={svgSetting[os]}
                  />
                ) : ''}
            </div>
          </div>
        </div>
      </DeviceContext.Provider>
    );
  }
}
export default Stage;
